import './App.css';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import AnimatedCursor from 'react-animated-cursor';

function App() {
	return (
		<Routes>
			<Route
				path="/"
				element={
					<div className="App">
						<Home />
						<AnimatedCursor color="0,198,171" innerSize={20} outerSize={20} />
					</div>
				}
			/>
		</Routes>
	);
}

export default App;
